<template>
  <div class="top" :class="{ isiOSX: isiOSX }">
    <div class="nav">
      <p class="back" @click="backtrack()">
        <img src="../../assets/selfSupport/backlast@2x.png" alt />
      </p>
      <p class="title">{{ title }}</p>
      <p class="esc" @click="onClickRight()" v-show="hasOrder">开发票</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isiOSX: false,
    };
  },
  props: {
    title: {
      type: String,
      default: "标题",
    },
    hasOrder: {
      type: Boolean,
      default: false,
    },
    back: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
  },
  watch: {
    $route: "getPath",
  },
  methods: {
    backtrack() {
      if (this.back == 1) {
        this.goBack();
      } else {
        // 返回上一页
        this.$router.go(-1);
      }
    },
    goBack() {
      // console.log("返回上一页");
      // 返回app上一页
      this.params("", "", "goBack");
    },
    onClickRight() {
      this.$router.push({
        path: "/takingCar/invoice",
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.top {
  background: #ffffff;
  box-shadow: 1px 2px 4px rgba(24, 24, 24, 0.06);
  padding-top: 24px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  .nav {
    margin: 0 21px;
    height: 46px;
    position: relative;
    p {
      height: 46px;
      line-height: 46px;
      font-size: 16px;
      color: #333333;
      img {
        width: 17px;
        height: 17px;
        transform: translateY(4px);
      }
    }
    p:nth-child(1) {
      position: absolute;
      top: 0;
      left: 0;
    }
    p:nth-child(2) {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    p:nth-child(3) {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
.isiOSX {
  padding-top: 44px;
}
</style>
